// Translations for the Domains section (former addon pages).
//
// Source strings are Russian and serve as keys; i18n.en.json maps them to
// English. Since the audit the Domains section uses the app-wide string
// translator (lib/tx): one language state, one lookup, and its dictionary
// is merged into tx's RU->EN table. tr / trf / setDomainsLang stay as
// aliases so the ~1000 call sites need no change.
import { tx, txf, setTxLang } from "../lib/tx";

export const tr = tx;
export const trf = txf;
export const setDomainsLang = setTxLang;
